import script from "./NavbarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarComponent.vue?vue&type=style&index=0&id=02b67b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b67b18"]])

export default __exports__